import { MenuItem } from './submenu.model';

export const MENU: MenuItem[] = [
  {
    label: 'Setup',
    icon: 'settings',
    link: '/setup',
  },
  {
    label: 'Project Types',
    link: '/type',
  },
  {
    label: 'Users',
    link: '/setup/users',
  },
  {
    label: 'Permissions & Groups',
    link: '/setup/permissions',
  },
];
